import type { Dayjs } from "dayjs";

export const calculateProgress = (
  currentTime: Dayjs,
  startTime: Dayjs,
  endTime: Dayjs
) => {
  return (currentTime.diff(startTime) / endTime.diff(startTime)) * 100;
};
